
  $(document).ready(function () {
    // Show Popup
    var footer = $('footer');
    console.log("footer",footer)
    $('#popup-button').click(function () {
        // $('#popup_out').show();
      $('#popup_out').css('display','flex');
        $('body').css('overflow', 'hidden')
    });

    // Hide Popup
    $('.exit-intent__close').click(function () {
      console.log("close")
        // $('#popup_out').hide();
       $('#popup_out').css('display','none');
      $('body').css('overflow', 'scroll')
    });
     $('.background').click(function(){
         $('#popup_out').css('display','none');
       $('body').css('overflow', 'scroll')
     })
});